import React from "react";

import { useUserContext } from "src/shared/contexts";

import AdminDashboard from "./components/AdminDashboard";
import VolunteerDashboard from "./components/VolunteerDashboard";

const VolunteerHome = () => {
  const { isOrganizer } = useUserContext();

  return <>{isOrganizer ? <AdminDashboard /> : <VolunteerDashboard />}</>;
};

export default VolunteerHome;
